import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Clock, Home, ArrowLeft, AlertTriangle } from 'lucide-react';

export function AgreementExpired() {
  const { agreement_id } = useParams<{ agreement_id: string }>();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-orange-100 mb-6">
            <Clock className="h-8 w-8 text-orange-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Agreement Expired
          </h1>
          <p className="text-lg text-gray-600 mb-6">
            This agreement has expired and is no longer available for completion.
          </p>
          {agreement_id && (
            <div className="bg-gray-100 rounded-lg p-4 mb-6">
              <p className="text-sm text-gray-700">
                <span className="font-medium">Agreement ID:</span> {agreement_id}
              </p>
            </div>
          )}
        </div>

        <div className="space-y-4">
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <AlertTriangle className="h-5 w-5 text-orange-600 mt-0.5 mr-3 flex-shrink-0" />
              <div className="text-left">
                <h3 className="text-sm font-medium text-orange-800 mb-1">
                  What happens now?
                </h3>
                <p className="text-sm text-orange-700">
                  Expired agreements cannot be completed or modified. Please contact your property consultant to discuss next steps or request a new agreement.
                </p>
              </div>
            </div>
          </div>

          <div className="text-sm text-gray-600">
            <p className="mb-4">An agreement may expire if:</p>
            <ul className="text-left space-y-2 max-w-xs mx-auto">
              <li className="flex items-start">
                <span className="text-orange-500 mr-2">•</span>
                The completion deadline has passed
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-2">•</span>
                It has been inactive for an extended period
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-2">•</span>
                The property is no longer available
              </li>
            </ul>
          </div>

          <div className="pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              Need assistance? Contact your property consultant or support team for help with this expired agreement.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}